module.exports = __webpack_public_path__ + "static/media/μακροβούτες_cover.9047efd5.png";